module.exports = __webpack_public_path__ + "static/media/ic-zoom-out-map.5fbe64fb.svg";